import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/store';
import { fetchNewsById } from '../store/slices/newsSlice';
import { Card, Spinner, Alert, Container, Button } from 'react-bootstrap';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

const NewsDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  
  const { currentItem, status, error } = useAppSelector((state) => ({
    currentItem: state.news.currentItem,
    status: state.news.status,
    error: state.news.error,
  }));

  useEffect(() => {
    if (id) {
      dispatch(fetchNewsById(parseInt(id)));
    }
  }, [dispatch, id]);

  if (status === 'loading') {
    return (
      <div className="d-flex justify-content-center my-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (status === 'failed') {
    return (
      <Alert variant="danger" className="m-3">
        <Alert.Heading>Ошибка загрузки новости</Alert.Heading>
        <p>{error || 'Произошла ошибка при загрузке новости'}</p>
        <Link to="/">
          <Button variant="primary">
            На главную
          </Button>
        </Link>
      </Alert>
    );
  }

  if (!currentItem) {
    return (
      <Container className="my-5">
        <Alert variant="warning">
          Новость не найдена
          <Link to="/" className="ms-3">
            <Button variant="outline-primary">
              На главную
            </Button>
          </Link>
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="my-5">
      <Link to="/">
        <Button variant="outline-secondary" className="mb-4">
          ← Назад к списку новостей
        </Button>
      </Link>
      
      <Card className="mb-4">
        {currentItem.image_url && (
          <Card.Img 
            variant="top" 
            src={currentItem.image_url} 
            alt={currentItem.title}
            className="img-fluid"
            style={{ maxHeight: '500px', objectFit: 'cover' }}
          />
        )}
        <Card.Body>
          <Card.Title as="h1">{currentItem.title}</Card.Title>
          
          <div className="d-flex justify-content-between align-items-center mb-3">
            {currentItem.category && (
              <Link 
                to={`/category/${currentItem.category.slug}`} 
                className="badge bg-primary text-decoration-none"
              >
                {currentItem.category.name}
              </Link>
            )}
            
            <small className="text-muted">
              {format(new Date(currentItem.created_at), 'd MMMM yyyy, HH:mm', { locale: ru })}
            </small>
          </div>
          
          <Card.Text className="lead">
            {currentItem.short_description}
          </Card.Text>
          
          <div className="mt-4">
            {currentItem.content || 'Содержимое новости отсутствует'}
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default NewsDetailPage;
